"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumber = void 0;
var formatPhoneNumber = function (phoneNumberString) {
    var cleaned = ('' + phoneNumberString.slice(4)).replace(/\D/g, '');
    var code = phoneNumberString.slice(0, 4);
    var match = cleaned.match(/^(\d{2})(\d{2})(\d{2})(\d{2})$/);
    if (match) {
        return (code +
            ' (' +
            match[1] +
            ') ' +
            match[2] +
            ' ' +
            match[3] +
            ' ' +
            match[4]);
    }
    return null;
};
exports.formatPhoneNumber = formatPhoneNumber;
